import React, { useEffect, useMemo, Dispatch, SetStateAction } from "react";
import { AxiosError } from "axios";
import { useQuery } from "react-query";
import { useParams, useRouteMatch } from "react-router-dom";

import { ApiError } from "fe-shared/src/types/common";
import { Invoice } from "fe-shared-transactions/src/types";

import { hasPermission } from "fe-shared/src/helpers/permissions";
import { Company, PermissionLevel } from "fe-shared/src/types/domain";

import { PERMISSIONS, INVOICES_QUERY_KEY } from "consts";

import InvoicesDetailsView from "../InvoicesDetailsView";

import * as api from "../modules/api";

interface Props {
  company: Company;
  setLastOpenedInvoiceNumber: Dispatch<SetStateAction<string | null>>;
}

const InvoicesDetailsViewContainer = ({
  company,
  setLastOpenedInvoiceNumber,
}: Props) => {
  const { invoiceNumber } = useParams<{ invoiceNumber: string }>();
  const { path } = useRouteMatch();
  const canViewInvoiceDetails = hasPermission(company?.permissions, {
    name: PERMISSIONS.invoiceDetails,
    level: PermissionLevel.Read,
  });
  const returnUrl = useMemo(() => path.replace("/:invoiceNumber", ""), [path]);

  useEffect(() => {
    if (invoiceNumber) {
      setLastOpenedInvoiceNumber(invoiceNumber);
    }
  }, [setLastOpenedInvoiceNumber, invoiceNumber]);

  const invoiceQueryKey = [INVOICES_QUERY_KEY, invoiceNumber];
  const invoice = useQuery<Invoice, AxiosError<ApiError>>(
    invoiceQueryKey,
    api.getInvoice,
    {
      keepPreviousData: true,
      enabled: canViewInvoiceDetails,
    }
  );

  return <InvoicesDetailsView returnUrl={returnUrl} invoice={invoice} />;
};

export default InvoicesDetailsViewContainer;
